import type { FC, ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';

import style from './style.scss';

interface Props {
  color?: 'blue' | 'green' | 'orange' | 'red' | 'grey' | 'dark_grey' | 'purple';
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const colorClassMap: { [key: string]: string } = {
  blue: style.tag_blue,
  green: style.tag_green,
  orange: style.tag_orange,
  red: style.tag_red,
  grey: style.tag_grey,
  dark_grey: style.tag_dark_grey,
  purple: style.tag_purple
};

const MarketTag: FC<Props> = ({ color = 'green', children, className, style: css }) => {
  const tagClassName = classnames(style.tag, colorClassMap[color], className);

  return (
    <div className={tagClassName} style={css}>
      {children}
    </div>
  );
};

MarketTag.displayName = 'MarketTag';

export default MarketTag;
